<template>
  <form class="position-relative">
    <loader :loading="loading" block />

    <v-card v-if="!loading">
      <v-card-title class="headline grey lighten-2 mb-4 justify-center" primary-title>
        Информация о заявке
      </v-card-title>

      <v-card-text>
        <h4 class="warning--text">{{ order.order_process_status }}</h4>
      </v-card-text>

      <v-card-text>
        <v-simple-table dense>
          <template v-slot:default>
            <tbody>
              <tr>
                <td>№ заказа:</td>
                <td>{{ order.id }}</td>
              </tr>

              <tr>
                <td>Дата заказа:</td>
                <td>{{ order.order_date }}</td>
              </tr>

              <tr>
                <td>Дата приёма:</td>
                <td>{{ order.appointment_date }}</td>
              </tr>

              <tr>
                <td>Услуга:</td>
                <td>{{ order.service }}</td>
              </tr>

              <tr>
                <td>Направлен из:</td>
                <td>{{ order.from_clinic }}</td>
              </tr>

              <tr>
                <td>Клиника:</td>
                <td>{{ order.to_clinic }}</td>
              </tr>

              <tr>
                <td>Врач:</td>
                <td>{{ order.doctor }}</td>
              </tr>

              <tr>
                <td>Пациент:</td>
                <td>{{ order.patient }}</td>
              </tr>

              <tr>
                <td>Статус:</td>
                <td>{{ order.order_status }}</td>
              </tr>

              <tr v-if="order.notes">
                <td>Примечания:</td>
                <td>{{ order.notes }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>

      <v-divider class="mt-4"></v-divider>

      <v-expansion-panels flat hover>
        <v-expansion-panel>
          <v-expansion-panel-header>ИСТОРИЯ ЗАЯВКИ</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>Пользователь</th>
                    <th>Предыдущий статус</th>
                    <th>Новый статус</th>
                    <th>Дата изменения статуса</th>
                    <th>Примечания</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(h, idx) in order.history" :key="h + idx">
                    <td>{{ h.user_modifier }}</td>
                    <td>{{ h.previous_status }}</td>
                    <td>{{ h.changed_status }}</td>
                    <td>{{ h.date_of_status_change }}</td>
                    <td>{{ h.notes }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="close">Закрыть</v-btn>
      </v-card-actions>
    </v-card>
  </form>
</template>

<script>
import Loader from "@/components/Loader";

export default {
  name: "ModalOrderHistory",

  components: { Loader },

  props: {
    /** @type {CustomerOrderHistory|Object} */
    order: {
      type: Object,
    },
  },

  data: () => ({
    loading: false,
    data: [],
  }),

  computed: {
    customerId() {
      return this.$store.state.customer.id;
    },
  },

  methods: {
    /**
     * Закрытия модального окна
     */
    close() {
      this.$emit("close");
      this.$emit("submit");
    },
  },
};
</script>
